export type { UseHeroHeightLockOptions } from "./useHeroHeightLock";
export { useHeroHeightLock } from "./useHeroHeightLock";
